module.exports = __webpack_public_path__ + "static/media/icon_hamburger.96ead2f8.svg";